import { useSelector } from 'react-redux'
import { LoginPhoneType } from '../../types/components'
import FormInput from '../FormInput'
import { InputWrapper, LoginPhoneNumberWrapper } from './styles'
import { RootState } from '../../redux/store'

const LoginPhoneNumber = ({
	name,
	type,
	label,
	value,
	changeHandler,
	onEnterPress,
}: LoginPhoneType) => {
	const translations = useSelector(
		(state: RootState) => state.translations.data
	)
	return (
		<LoginPhoneNumberWrapper>
			<InputWrapper width="12%" value={translations.PHONE_CODE} disabled />
			<FormInput
				marginTop="40px"
				name={name}
				type={type}
				label={label}
				value={value}
				handleChange={changeHandler}
				errorMessage=""
				isValid={false}
				showError={false}
				onEnterPress={onEnterPress}
				autofocus={true}
			/>
		</LoginPhoneNumberWrapper>
	)
}

export default LoginPhoneNumber
